import React from 'react';
import { motion } from 'framer-motion';

interface TestimonialQuoteProps {
  quote: string;
  author: string;
}

export const TestimonialQuote: React.FC<TestimonialQuoteProps> = ({ quote, author }) => {
  return (
    <motion.blockquote 
      className="glass p-6 border-l-4 border-neon-green"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
    >
      <p className="text-lg italic text-gray-300">{quote}</p>
      <footer className="text-gray-400 mt-2">- {author}</footer>
    </motion.blockquote>
  );
};